// @flow
import keymirror from 'keymirror';

export default keymirror({
  HORIZONTAL: null,
  RECTANGLE: null,
  VERTICAL: null,
  MOBILE: null,
  MOBILE_BIG: null,
  MOBILE_HORIZONTAL: null,
  PORTRET: null,
  BILBORD: null,
  FLUID: null,
});
